import { Skeleton } from '@/components/ui/skeleton';

interface TemplatesSkeletonProps {
  rowCount?: number;
}

/**
 * Loading placeholder for the templates table — N grey row shapes
 * matching the real row layout. Renders while `useTemplates` is
 * pending (A4 / D34) so the page doesn't pop from empty to populated.
 */
export function TemplatesSkeleton({ rowCount = 5 }: TemplatesSkeletonProps) {
  return (
    <div className="space-y-2">
      {Array.from({ length: rowCount }).map((_, i) => (
        <div key={i} data-skeleton-row className="flex items-center gap-4 rounded-md border p-3">
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-5 w-20" />
          <Skeleton className="h-5 w-32" />
          <Skeleton className="h-5 w-24" />
          <Skeleton className="ml-auto h-8 w-8 rounded-full" />
        </div>
      ))}
    </div>
  );
}
